module.exports = __webpack_public_path__ + "media/images/emblems/Gruyeres-coat_of_arms-8f38a0fce63d868c4f932540687feb77.svg";